document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('path,rect,polygon,circle,line,text').forEach(e => {
    // replace the fill colors
    const fillColor = e.getAttribute('fill')
    const strokeColor = e.getAttribute('stroke')

    switch (true) {
      case (fillColor === '#4E4745' || strokeColor === '#4E4745'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-dark-gray)');
        break;
      case (fillColor === 'white' || strokeColor === 'white'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-white)');
        break;
      case (fillColor === '#006A7A' || strokeColor === '#006A7A'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-dark-green)');
        break;
      case (fillColor === '#007B7C' || strokeColor === '#007B7C'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-dark-green)');
        break;
      case (fillColor === '#E5F2F4' || strokeColor === '#E5F2F4'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-light-green-gray)');
        break;
      case (fillColor === '#FDE6F1' || strokeColor === '#FDE6F1'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-light-red-gray)');
        break;
      case (fillColor === '#D6006B' || strokeColor === '#D6006B'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-red)');
        break;
      case (fillColor === '#008094' || strokeColor === '#008094'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-green)');
        break;
      case (fillColor === '#E60073' || strokeColor === '#E60073'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-light-red)');
        break;
      case (fillColor === '#9A9695' || strokeColor === '#9A9695'):
        e.setAttribute(fillColor ? 'fill' : 'stroke', 'var(--color-gray)');
        break;
      default:
        e.setAttribute(fillColor ? 'fill' : 'stroke', fillColor ? fillColor : strokeColor);
    }
  });
})
